import { FC, ReactElement } from 'react'
import { generatePath, Navigate } from 'react-router-dom'

import { UiElement, useUiVisibility } from 'modules/projects/hooks'
import { useProfile } from 'modules/user/queries'
import { Routes } from 'routes/routes'
import { Loader, LoaderTypes } from 'ui/Loader'

interface UiVisibilityGuardProps {
  element: UiElement
  children: ReactElement
}

/**
 * Раздел, который админ может скрыть в «Отображении интерфейса» проекта.
 *
 * Скрытый раздел по прямой ссылке уводит на список сценариев — его скрыть нельзя,
 * поэтому редирект не зацикливается. Пока проект грузится — лоадер, без редиректа.
 */
export const UiVisibilityGuard: FC<UiVisibilityGuardProps> = ({ element, children }) => {
  const { isVisible, isLoadingProject } = useUiVisibility()
  const { profile } = useProfile()

  if (isLoadingProject) {
    return <Loader type={LoaderTypes.SpinnerCenter} />
  }

  if (!isVisible(element)) {
    const projectId = profile?.activeProjectId
    return (
      <Navigate
        replace
        to={projectId ? generatePath(Routes.Scenarios, { projectId: String(projectId) }) : Routes.DataSources}
      />
    )
  }

  return children
}
